import { z } from 'zod'

export const ippForecastSchema = z
	.object({
		reason: z.string().refine((data) => data.length !== 0, {
			message: 'Required',
			path: ['reason'],
		}),
	})
	.strict()
